import http from '../../assets/http'
import Qs from 'qs'
function extendjs(Vue) {
  if (extendjs.installed) {
    return
  }
  // 时间格式化全局方法
  Vue.prototype.dateFormatCustom = function dateFormatCustom (dateObj, format) {
    if (!dateObj) {
      return ''
    }
    if (!(dateObj instanceof Date)) {
      dateObj = new Date(dateObj * 1)
    }
    let date = {
      'M+': dateObj.getMonth() + 1,
      'd+': dateObj.getDate(),
      'h+': dateObj.getHours(),
      'm+': dateObj.getMinutes(),
      's+': dateObj.getSeconds(),
      'q+': Math.floor((dateObj.getMonth() + 3) / 3),
      'S+': dateObj.getMilliseconds()
    }
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in date) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1
          ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
      }
    }
    return format
  }
  Vue.prototype.$http = http
  Vue.prototype.$qs = Qs
  Vue.prototype.$wxlogin = function (type,state) {

  }
  Vue.prototype.$downloadPDF=function (url,name) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function(e) {
      if (this.status == 200) {
        var blob = new Blob([this.response], {type: 'application/pdf'});
        var downloadUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = downloadUrl;
        a.download = name+".pdf";
        document.body.appendChild(a);
        a.click();
      }
    };
    xhr.send();
  }
  Vue.prototype.uuid = function() {
    let s = []
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'
    return s.join('')
  }
  Vue.prototype.openNewPage=function (url){
    let _url=this.$router.resolve({
      path:url
    })
    window.open(_url.href,"_blank")
  }
  Vue.prototype.fileFormatTime = date => {
    const formatNumber = n => {
      n = n.toString()
      return n[1] ? n : `0${n}`
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()

    return `${[year, month, day].map(formatNumber).join('')}${[hour, minute].map(formatNumber).join('')}`
  }
  //获取32随机数
  Vue.prototype.randomWord=function () {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    var nums = "";
    for (var i = 0; i < 32; i++) {
      var id = parseInt(Math.random() * 61);
      nums += chars[id];
    }
    return nums;
  }
  Vue.prototype.alertDialog=function (title, callback){
    this.$confirm(title, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      callback()
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      });
    });
  }
  // //自定义指令
  // Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
  //   let imgURL = binding.value // 获取图片地址
  //   if (imgURL) {
  //     let exist = await imageIsExist(imgURL)
  //     if (exist) {
  //       el.setAttribute('src', imgURL)
  //     }
  //   }
  // })
  // let imageIsExist = function (url) {
  //   return new Promise((resolve) => {
  //     var img = new Image()
  //     img.onload = function () {
  //       if (this.complete === true) {
  //         resolve(true)
  //         img = null
  //       }
  //     }
  //     img.onerror = function () {
  //       resolve(false)
  //       img = null
  //     }
  //     img.src = url
  //   })
  // }
}

export default extendjs



// WEBPACK FOOTER //
// ./src/assets/globalJS/extend.js